import { createFileRoute } from "@tanstack/react-router";

import { BASE_URL, OG_VERSION } from "@/common/links";
import { PrivacyContent } from "@/landing/legal/PrivacyContent";
import { PAGE_META } from "@/landing/lib/page-meta";

export const Route = createFileRoute("/_steward/privacy")({
  component: PrivacyContent,
  head: () => ({
    meta: [
      { title: PAGE_META["/privacy"].title },
      { name: "description", content: PAGE_META["/privacy"].description },
      { property: "og:title", content: PAGE_META["/privacy"].title },
      {
        property: "og:description",
        content: PAGE_META["/privacy"].description,
      },
      {
        property: "og:image",
        content: `${BASE_URL}/og/privacy.png?v=${OG_VERSION}`,
      },
      { name: "twitter:title", content: PAGE_META["/privacy"].title },
      {
        name: "twitter:description",
        content: PAGE_META["/privacy"].description,
      },
      {
        name: "twitter:image",
        content: `${BASE_URL}/og/privacy.png?v=${OG_VERSION}`,
      },
    ],
    links: [{ rel: "canonical", href: `${BASE_URL}/privacy` }],
  }),
});
